import { useReactToPrint } from 'react-to-print';
import { MindMapContext } from '../../Context/contex';
import './printMindMap.css';

/** Returns a function that prints the canvas; printMindMap.css hides the header and panels. */
export const usePrintMindMap = () => {
    const { mindmapWrapper } = MindMapContext();

    return useReactToPrint({
        content: () => mindmapWrapper.current,
    });
};
